// src/index.js
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import $ from "jquery";
import "slick-carousel";

// Show/hide scroll arrow
const scrollArrow = document.querySelector(".scroll-arrow");
if (scrollArrow) {
  window.addEventListener("scroll", () => {
    if (window.scrollY > 100) {
      scrollArrow.classList.remove("opacity-0");
    } else {
      scrollArrow.classList.add("opacity-0");
    }
  });
}

// Show/hide tooltips
document.addEventListener("DOMContentLoaded", () => {
  const popup = document.querySelector(".cursor-popup");
  const triggers = document.querySelectorAll(".hover-trigger");
  const toggleSwitch = document.getElementById("popupToggle");
  const cursor = document.querySelector(".cursor-dot");
  let activeElement = null;
  let showTimeout = null;
  let isVisible = false;
  let currentX = 0;
  let currentY = 0;
  let targetX = 0;
  let targetY = 0;
  const SHOW_DELAY = 50;
  const TRAIL_SPEED = 0.1; // Adjust between 0 and 1 (lower = more delay)

  function lerp(start, end, factor) {
    return start + (end - start) * factor;
  }

  function updatePopupPosition() {
    if (activeElement && toggleSwitch.checked && isVisible) {
      // Smooth interpolation between current and target positions
      currentX = lerp(currentX, targetX, TRAIL_SPEED);
      currentY = lerp(currentY, targetY, TRAIL_SPEED);

      popup.style.left = `${currentX}px`;
      popup.style.top = `${currentY}px`;
    }
    requestAnimationFrame(updatePopupPosition);
  }

  function showPopup(e) {
    if (activeElement && toggleSwitch.checked) {
      const title = activeElement.dataset.popupTitle;
      const content = activeElement.dataset.popupContent;

      // Create popup HTML with title and content
      popup.innerHTML = `
        ${title ? `<h4 class="popup-title">${title}</h4>` : ""}
        ${content ? `<p>${content}</p>` : ""}
      `;

      popup.style.display = "block";

      // Initialize positions
      currentX = e.clientX;
      currentY = e.clientY;
      targetX = e.clientX;
      targetY = e.clientY;

      if (!isVisible) {
        popup.classList.add("active");
        isVisible = true;
      }
    }
  }

  function handleMouseMove(e) {
    if (!activeElement) return;

    targetX = e.clientX;
    targetY = e.clientY;
  }

  function showPopupWithDelay(e) {
    if (showTimeout) {
      clearTimeout(showTimeout);
    }

    showTimeout = setTimeout(() => {
      showPopup(e);
    }, SHOW_DELAY);
  }

  triggers.forEach((trigger) => {
    trigger.addEventListener("mouseenter", (e) => {
      activeElement = trigger;
      showPopupWithDelay(e);
    });

    trigger.addEventListener("mousemove", handleMouseMove);

    trigger.addEventListener("mouseleave", () => {
      activeElement = null;
      isVisible = false;
      if (showTimeout) {
        clearTimeout(showTimeout);
      }
      popup.classList.remove("active");
      setTimeout(() => {
        if (!popup.classList.contains("active")) {
          popup.style.display = "none";
        }
      }, 200);
    });
  });

  // Add cursor tracking
  if (cursor && triggers.length > 0) {
    document.addEventListener("mousemove", (e) => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
    });

    // Show/hide cursor on hover
    triggers.forEach((trigger) => {
      trigger.addEventListener("mouseenter", () => {
        cursor.style.opacity = "1";
      });

      trigger.addEventListener("mouseleave", () => {
        cursor.style.opacity = "0";
      });
    });
  }

  // Start the animation loop
  requestAnimationFrame(updatePopupPosition);

  // Only add toggle switch listener if element exists
  if (toggleSwitch) {
    toggleSwitch.addEventListener("change", () => {
      if (!toggleSwitch.checked) {
        popup.style.display = "none";
        popup.classList.remove("active");
        isVisible = false;
      } else if (activeElement) {
        showPopup();
      }
    });
  }

  // Add intersection observer for text animations
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  };

  const textObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("visible");
        textObserver.unobserve(entry.target); // Stop observing once visible
      }
    });
  }, observerOptions);

  // Add intersection observer for slide animations
  const slideObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          slideObserver.unobserve(entry.target); // Stop observing once visible
        }
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    }
  );

  // Observe all sections with the 'slide' class
  document.querySelectorAll(".slide").forEach((section) => {
    slideObserver.observe(section);
  });

  // Handle image loading
  document.querySelectorAll('img[loading="lazy"]').forEach((img) => {
    if (!img.complete) {
      img.classList.add("placeholder");
    }
  });

  // Handle video container loading
  document.querySelectorAll(".video-container").forEach((container) => {
    if (container.dataset.videoLoaded !== "true") {
      container.classList.add("placeholder");
    }
  });
});

// Wait for all images to load before initializing the observer
window.addEventListener("load", () => {
  const observerOptions = {
    root: null,
    rootMargin: "-20% 0px -20% 0px",
    threshold: [0, 0.25, 0.5, 0.75, 1], // Multiple thresholds for better accuracy
  };

  let currentSection = null;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const id = entry.target.getAttribute("id");
      const tocLink = document.querySelector(
        `.table-of-contents a[href="#${id}"]`
      );

      // Calculate visibility ratio
      const ratio = entry.intersectionRatio;

      if (entry.isIntersecting && ratio > 0.25) {
        // Adjust threshold as needed
        if (currentSection !== id) {
          // Remove active class from all links
          document.querySelectorAll(".table-of-contents a").forEach((link) => {
            link.classList.remove("active");
          });

          // Add active class to current section link
          if (tocLink) {
            tocLink.classList.add("active");
            currentSection = id;

            // Highlight parent list item if it's a nested item
            const parentLi = tocLink.closest("ul").closest("li");
            if (parentLi) {
              const parentLink = parentLi.querySelector("a");
              if (parentLink) {
                parentLink.classList.add("active");
              }
            }
          }
        }
      }
    });
  }, observerOptions);

  // Observe all sections that have an ID
  document.querySelectorAll("section[id]").forEach((section) => {
    observer.observe(section);
  });
});

// Optional: Add scroll event listener as a fallback
window.addEventListener(
  "scroll",
  () => {
    const sections = document.querySelectorAll(
      "section[id], .services-list li[id], .work-list li[id]"
    );

    sections.forEach((section) => {
      const id = section.getAttribute("id");
      const tocLink = document.querySelector(
        `.table-of-contents a[href="#${id}"]`
      );

      const rect = section.getBoundingClientRect();
      const isVisible =
        rect.top <= window.innerHeight / 2 &&
        rect.bottom >= window.innerHeight / 2;

      if (isVisible && tocLink) {
        document.querySelectorAll(".table-of-contents a").forEach((link) => {
          link.classList.remove("active");
        });
        tocLink.classList.add("active");
      }
    });
  },
  { passive: true }
);

// Hero video loading overlay - hide when Vimeo is ready
document.addEventListener("DOMContentLoaded", () => {
  const heroVideoLoading = document.getElementById("hero-video-loading");
  const heroIframe = document.querySelector('iframe[title="Khromatik intro"]');

  function hideLoadingOverlay() {
    if (!heroVideoLoading) return;
    heroVideoLoading.style.opacity = "0";
    heroVideoLoading.style.pointerEvents = "none";
    setTimeout(() => {
      heroVideoLoading.style.display = "none";
    }, 500);
  }

  if (heroVideoLoading && heroIframe) {
    if (typeof Vimeo !== "undefined") {
      const player = new Vimeo.Player(heroIframe);
      player
        .ready()
        .then(hideLoadingOverlay)
        .catch(() => {
          setTimeout(hideLoadingOverlay, 5000);
        });
    } else {
      // Fallback: hide when iframe loads (less accurate but works without API)
      heroIframe.addEventListener("load", () => {
        setTimeout(hideLoadingOverlay, 1500);
      });
    }
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const cursor = document.querySelector(".cursor-eye");
  const workItems = document.querySelectorAll(
    ".services-list a, .archive-list a, .work-list li[id]"
  );

  // Initialize slick carousel
  $(".carousel").slick({
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: "linear",
    autoplay: true,
    autoplaySpeed: 3000,
  });

  if (cursor && workItems.length > 0) {
    // Initial position
    cursor.style.opacity = "0";

    // Add blink animation class to SVG path
    const eyeLid = cursor.querySelector("svg path");
    if (eyeLid) {
      eyeLid.classList.add("eye-lid");
    }

    document.addEventListener("mousemove", (e) => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
    });

    workItems.forEach((item) => {
      item.addEventListener("mouseenter", () => {
        cursor.style.opacity = "1";
      });

      item.addEventListener("mouseleave", () => {
        cursor.style.opacity = "0";
      });
    });
  }
});
